import { render, staticRenderFns } from "./UComment.vue?vue&type=template&id=e538319e&"
import script from "./UComment.vue?vue&type=script&lang=js&"
export * from "./UComment.vue?vue&type=script&lang=js&"
import style0 from "./UComment.vue?vue&type=style&index=0&id=e538319e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports